import { useNavigate } from 'react-router-dom'
import { PageNavigation } from '../../../types/routing-types'
import { HandleSave } from '../../hooks/use-edit-form'
import WellEditButtons, { ActionProps, WellButtonLabels } from './well-edit-buttons'

interface WellDetailsEditButtonsProps {
  urls: PageNavigation
  handleSave: HandleSave
  omitButton?: WellButtonLabels[]
  disableButtons?: WellButtonLabels[]
}

export default function EditRecordButtons({ urls, handleSave, disableButtons }: WellDetailsEditButtonsProps) {
  const navigate = useNavigate()

  const baseNavigationState = {
    isProgrammaticTransition: true,
  }

  const saveNavigationState = {
    ...baseNavigationState,
    ...(urls.navigateToSaveRouteState && { ...urls.navigateToSaveRouteState }),
  }

  const saveAndContinueNavState = {
    ...baseNavigationState,
    ...(urls.navigateToSaveAndContinueRouteState && { ...urls.navigateToSaveAndContinueRouteState }),
  }

  const cancelNavState = {
    ...baseNavigationState,
    ...(urls.cancelRouteState && { ...urls.cancelRouteState }),
  }

  const actions: (disableButtons: WellButtonLabels[] | undefined) => ActionProps[] = () => {
    return [
      {
        label: urls.saveAndNavigateLabel ?? 'Save and continue',
        buttonStyle: 'primary',
        onClick: () =>
          handleSave(async (id, refetch) => {
            await refetch?.()
            const navigateRoute = urls.saveAndContinueRoute(id)
            if (typeof navigateRoute === 'string') {
              navigate(navigateRoute, { state: saveAndContinueNavState })
            } else if (urls.saveAndReturnRoute) {
              navigate(urls.saveAndReturnRoute, { state: saveAndContinueNavState })
            } else {
              urls.saveAndContinueRoute(id)
            }
          }),
        isDisabled: disableButtons?.includes(urls.saveAndNavigateLabel || 'Save and continue'),
      },
      {
        label: 'Save',
        buttonStyle: 'primary',
        onClick: () => {
          handleSave(async (id, refetch) => {
            await refetch?.()
            if (urls.saveRouteNewId) {
              navigate(urls.saveRouteNewId(id), { state: saveNavigationState })
            }
          })
        },
        isDisabled: disableButtons?.includes('Save'),
      },
      {
        label: urls.cancelButtonLabel ?? 'Return to view',
        buttonStyle: 'text-action',
        onClick: () => navigate(urls.cancelRoute, { state: cancelNavState }),
      },
    ]
  }

  return (
    <WellEditButtons
      actions={
        urls.omitButtons?.length
          ? actions(disableButtons).filter((action) => !urls?.omitButtons?.includes(action.label))
          : actions(disableButtons)
      }
    />
  )
}
